module.exports = __webpack_public_path__ + "img/call_silent.db614c98.svg";